import { ModalitiesId } from "@/data/modalities";
import { TurnDetectionTypeId } from "@/data/turn-end-types";
import { VoiceId } from "@/data/voices";

import { defaultCustomFeedbackInstructions } from "./default-feedback-instructions";
import { ModelId } from "./models";
import { TranscriptionModelId } from "./transcription-models";

import type { Preset } from "./presets";

export interface SessionConfig {
	model: ModelId;
	transcriptionModel: TranscriptionModelId;
	turnDetection: TurnDetectionTypeId;
	modalities: ModalitiesId;
	voice: VoiceId;
	temperature: number;
	maxOutputTokens: number | null;
	vadThreshold: number;
	vadSilenceDurationMs: number;
	vadPrefixPaddingMs: number;
}

export interface PlaygroundState {
	sessionConfig: SessionConfig;
	userPresets: Preset[];
	selectedPresetId: string | null;
	openaiAPIKey: string | null | undefined;
	instructions: string;
}

export const defaultSessionConfig: SessionConfig = {
	model: ModelId.gpt_4o,
	transcriptionModel: TranscriptionModelId.whisper1,
	turnDetection: TurnDetectionTypeId.server_vad,
	modalities: ModalitiesId.text_and_audio,
	voice: VoiceId.alloy,
	temperature: 0.8,
	maxOutputTokens: null,
	vadThreshold: 0.5,
	vadSilenceDurationMs: 200,
	vadPrefixPaddingMs: 300,
};

// Define the initial state
export const defaultPlaygroundState: PlaygroundState = {
	sessionConfig: { ...defaultSessionConfig },
	userPresets: [],
	selectedPresetId: "helpful-ai",
	openaiAPIKey: undefined,
	instructions: defaultCustomFeedbackInstructions,
};
